import { Box, IconButton, Tooltip } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { SkuUserAgreementStatusIds } from "types/common-types";
import { useNavigate } from "react-router-dom";
import useGlobalContext from "hooks/globalData";

export type SkuResourceActionProps = {
  isSkuUserAgreementAccepted: boolean | undefined;
  isSkuUserAgreementPending: boolean | undefined;
  hasOrganizationUserId: boolean | undefined;
  organizationUserId?: string | undefined;
  skuId?: string;
};

const SkuResourceActionButtons = (
  skuResourceAction: SkuResourceActionProps
) => {
  const navigate = useNavigate();
  const {
    skuUserAgreementsUrl,
    skuUserAgreementCreateUrl,
  } = useGlobalContext();

  return (
    <Box justifyContent="center" display="flex">
      {skuResourceAction.isSkuUserAgreementAccepted && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            navigate({
              pathname: skuUserAgreementsUrl(),
              search: `?userId=${skuResourceAction.organizationUserId}&statusId=${SkuUserAgreementStatusIds.Accepted}`,
            });
          }}
        >
          <Tooltip title="Approved Agreement(s)" placement="top">
            <AssignmentTurnedInIcon color="success" />
          </Tooltip>
        </IconButton>
      )}

      {skuResourceAction.isSkuUserAgreementPending && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            navigate({
              pathname: skuUserAgreementsUrl(),
              search: `?userId=${skuResourceAction.organizationUserId}&statusId=${SkuUserAgreementStatusIds.Pending}`,
            });
          }}
        >
          <Tooltip title="Agreement(s) Pending Approval" placement="top">
            <AssignmentLateIcon />
          </Tooltip>
        </IconButton>
      )}

      {skuResourceAction.hasOrganizationUserId && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            navigate({
              pathname: skuUserAgreementCreateUrl(),
              search: `?userId=${skuResourceAction.organizationUserId}&skuId=${skuResourceAction.skuId}`,
            });
          }}
        >
          <Tooltip title="Add Agreement" placement="top">
            <AddBoxIcon />
          </Tooltip>
        </IconButton>
      )}
    </Box>
  );
};

export default SkuResourceActionButtons;
